import React from 'react';
interface BulletListProps {
  items: string[];
  marker: '✔' | '✨';
}
export function BulletList({
  items,
  marker
}: BulletListProps) {
  return <ul className="space-y-5" data-id="element-1">
      {items.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-2">
          <span aria-hidden="true" className="mt-0.5 flex-shrink-0 select-none text-lg leading-7 text-[#C9A24B]" data-id="element-3">
            {marker}
          </span>
          <span className="text-[17px] leading-[1.7] text-[#F5EDE4] sm:text-[18px]" data-id="element-4">
            {item}
          </span>
        </li>)}
    </ul>;
}